import React, { Component } from 'react';
import { langFromSlug, slugFromLang, buildPath, isValidLangSlug } from '../utils/route_utils';
import { setCookie } from '../utils/cookie_utils';

/**
 * HOC wrapper that extracts language from URL params and provides
 * lang + navigation helpers to wrapped page components.
 *
 * Usage: <LangRoute component={MainPage} />
 * The wrapped component receives: lang, updateLang, navigate
 */
class LangRoute extends Component {
  constructor(props) {
    super(props);

    // Extract lang and other params from URL
    const pathParts = window.location.pathname.split('/').filter(Boolean);
    const langSlug = pathParts[0] || 'zh-tw';
    const lang = isValidLangSlug(langSlug) ? langFromSlug(langSlug) : 'zh';

    // Set cookie for persistence
    setCookie('lang', lang, 30);

    this.state = { lang };
    this.updateLang = this.updateLang.bind(this);
    this.navigate = this.navigate.bind(this);
  }

  updateLang(newLang) {
    setCookie('lang', newLang, 30);
    this.setState({ lang: newLang });

    // Navigate to same page with new language prefix
    const path = window.location.pathname;
    const pathParts = path.split('/').filter(Boolean);
    // Remove the old lang slug, keep the rest
    if (isValidLangSlug(pathParts[0])) {
      pathParts.shift();
    }
    const route = '/' + pathParts.join('/');
    window.location.href = buildPath(newLang, route);
  }

  navigate(route) {
    window.location.href = buildPath(this.state.lang, route);
  }

  render() {
    const PageComponent = this.props.component;
    return (
      <PageComponent
        lang={this.state.lang}
        updateLang={this.updateLang}
        navigate={this.navigate}
      />
    );
  }
}

export default LangRoute;
